import React, { useContext } from 'react';
import LanguageContext from './LanguageContext';
import './styles.css';

const languageLabels = {
  fr: 'Français',
  en: 'English',
  zh: '中文'
};

const HomePage = ({ navigate }) => {
  const { setLanguage } = useContext(LanguageContext);

  const handleLanguageSelect = (lang) => {
    setLanguage(lang);
    navigate('/wine');
  };

  return (
    <div className="homepage">
      <img src="/blason-header.svg" alt="Logo" className="homepage-logo" />
      <h1 className="homepage-title">Code des Millésimes © 2025</h1>
      <div className="homepage-buttons">
        {Object.entries(languageLabels).map(([code, label]) => (
          <button key={code} onClick={() => handleLanguageSelect(code)} className="homepage-button language-button">
  {label}
</button>

        ))}
      </div>
    </div>
  );
};

export default HomePage;
